import * as RD from "src/types/remoteData";
import { Table, TableProps } from "./Table";

type Props<T> = {
  data: RD.RemoteData<unknown, T[]>;
  banner?: (data: T[]) => JSX.Element;
} & Omit<TableProps<T>, "data" | "isLoading" | "banner">;
export function RemoteDataTable<T>({
  data: remoteData,
  banner,
  ...props
}: Props<T>) {
  if (remoteData.isLoading()) {
    return <Table<T> data={[]} isLoading={true} {...props} />;
  }

  const data: T[] = remoteData.hasData() ? remoteData.data : [];

  return (
    <Table<T>
      data={data}
      banner={banner ? () => banner(data) : undefined}
      {...props}
    />
  );
}
